// Messages for portal/quotes/QuoteStatusBadge (auto-merged by lib/i18n.ts).
export const en = {
  'portal.quote_status.pending': 'Pending',
  'portal.quote_status.confirmed': 'Accepted',
  'portal.quote_status.rejected': 'Declined',
  'portal.quote_status.expired': 'Expired',
  'portal.quote_status.booked': 'Booked',
}

export const zhTW = {
  'portal.quote_status.pending': '待處理',
  'portal.quote_status.confirmed': '已接受',
  'portal.quote_status.rejected': '已拒絕',
  'portal.quote_status.expired': '已過期',
  'portal.quote_status.booked': '已訂艙',
}
